<template>
    <div class="qqmap-container" ref="qqmap-container">

        <div class="qqmap-map-section" ref="qqmap-map-section"></div>

        <div class="qqmap-top-section">

            <div class="t1" v-if="!routeLineSate">

                <div class="back iconfont icon-left-01" @click="back"></div>

                <div class="input-box" :class="{'value':searchResult}" @click="$router.push('/qqSearch')">
                    <i class="iconfont icon-search"></i>
                    <div class="input">{{ searchResult || searchPlaceholder}}</div>
                    <i class="iconfont icon-close-01" @click.stop="closeSearch"></i>
                </div>

            </div>


            <div class="t2" v-else>
                <div class="back iconfont icon-left-01" @click="back1"></div>
                <span>{{routeLineName}}</span>
            </div>
        </div>

        <div class="qqmap-bottom-section">

            <!--深圳会展信息-->
            <div class="b1" v-if="!trafficState && !routeLineSate">

                <div class="brtmap-enter iconfont icon-shinei2" @click="enterBrtMap"></div>

                <div class="intro-box">

                    <div class="content">

                        <p class="title">深圳国际会展中心</p>

                        <p class="address">
                            <span v-if="GPSDistant">{{GPSDistant > 1000 ? Math.ceil(GPSDistant/1000) + 'km' : Math.ceil(GPSDistant) + 'm' }}</span>
                            <span>广东省深圳市宝安区福海街道展城路1号</span>
                        </p>

                    </div>

                    <div class="btn">

                        <a @click="getRimTraffic">
                            <i class="iconfont icon-gongjiaoche"></i>
                            <span>周边交通</span>
                        </a>

                        <a class="active" @click="startNav">
                            <i class="iconfont icon-nav"></i>
                            <span>来馆导航</span>
                        </a>

                    </div>

                </div>

            </div>

            <!--周边交通信息-->
            <div class="b2" :state="trafficState" v-else-if="!routeLineSate">

                <div class="fold" @click="trafficState == 1 ? trafficState=2 : trafficState=1">
                    <i class="iconfont icon-up-01" v-if="trafficState !=2"></i>
                    <i class="iconfont icon-down-01" v-else></i>
                </div>

                <div class="tabs">

                    <div class="l">
                        <ul>
                            <li v-for="(item,index) in tabs" @click.stop="getRimTraffic(item,index)" :class="{'active':index==tabsIndex}"><a>{{item.name}}</a></li>
                        </ul>
                    </div>

                    <div class="r">
                        <a class="active" @click="startNav">
                            <i class="iconfont icon-nav"></i>
                            <span>来馆导航</span>
                        </a>
                    </div>

                </div>

                <div class="traffic-min">
                    共找到"周边{{searchResult}}"相关结果<font>{{traffic.length > 10 ? 10:traffic.length}}</font>个
                </div>

                <div class="content" ref="trafficScroll">

                    <div class="tip" v-if="trafficState==1 && traffic.length">
                        注:最多标记且显示周边10个结果，向上展开可查看全部
                    </div>

                    <ul v-if="traffic.length"  >
                        <li v-for="(item,index) in traffic" v-if="(trafficState==1 && index<10) || trafficState==2" @click="goHere(item)">

                            <div class="l">
                                <div class="title">{{item.name}}</div>

                                <div class="box">

                                    <div class="l" v-if="item.dist">
                                        <span>{{item.dist}}m</span>
                                    </div>

                                    <div class="r" v-if="item.address.length">
                                        <span v-for="child in item.address">{{child}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="r">

                                <div class="icon">
                                    <i class="iconfont icon-route"></i>
                                    <span>到这去</span>
                                </div>

                            </div>
                        </li>

                    </ul>

                    <div class="load-box" v-else-if="trafficLoad">
                        <div class="load">
                            <i class="iconfont icon-jiazai11"></i>
                            <i class="iconfont icon-location-2"></i>
                        </div>
                    </div>

                    <div class="empty" v-else>

                        <div class="box">
                            <i class="iconfont icon-gongjiaoche"></i>
                            <span>暂无该数据</span>
                        </div>

                    </div>

                </div>

            </div>

            <!--路线方案显示信息-->
            <div class="b3" v-else>

                <div class="brtmap-enter iconfont icon-shinei2" @click="showBrtRouteEvent" v-if="routeLines && showBrtRoute && routeLineSate!=2">
                    <!--室内路线-->
                </div>

                <div class="main-sec" :class="{'car':carModel}" :state="routeLineSate" v-if="routeLines">

                    <div class="t">

                        <div class="fold" @click="routeLineSate == 1 ? routeLineSate=2 : routeLineSate=1">
                            <i class="iconfont icon-up-01" v-if="routeLineSate !=2"></i>
                            <i class="iconfont icon-down-01" v-else></i>
                        </div>

                        <div class="title">
                            <div class="l">
                                <span>{{routeLines.id + 1}}</span>
                            </div>

                            <div class="r">
                                <p class="p1">{{routeLines.name}}</p>
                                <p class="p2">{{routeLines.time}}</p>
                            </div>
                        </div>


                        <div class="btn-box" @click="startNav('1')">
                            <a>开始导航</a>
                        </div>

                    </div>

                    <div class="c" ref="routeLinesScroll">
                        <ul>
                            <li class="start"><i class="iconfont icon-weizhi"></i><span>当前位置</span></li>
                            <li v-for="(item,index) in routeLines.nodes"><i>{{index + 1}}</i><span>{{item.instructions}}</span></li>
                            <li class="end"><i class="iconfont icon-weizhi"></i><span>{{routeLineName}}</span></li>
                        </ul>
                    </div>

                </div>

                <div class="load-box" v-else-if="routeLoad">
                    <div class="load">
                        <i class="iconfont icon-jiazai11"></i>
                        <i class="iconfont icon-location-2"></i>
                    </div>
                </div>

                <div class="empty-box" v-else>
                    <div class="wrap">
                        <i class="iconfont icon-luxian"></i>
                        <span>暂无该路线</span>
                    </div>
                </div>

            </div>
        </div>

        <div class="GPS-model" v-if="GPSModel">
            <div class="wrap">
                <div class="content">
                    <p class="p1">打开定位服务</p>
                    <div class="c">
                        请打开"定位服务"来允许<br>
                        "深圳国际会展中心"确定您的位置
                    </div>
                </div>

                <div class="btn">
                    <a @click="GPSModel=false">知道了</a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    //乘车规划多节点记录
    let routeNodes = [];

    export default {
        name: "Map",
        data(){
            return {

                isMounted:false,

                searchPlaceholder:'搜索室外目的地',
                searchResult:'',
                GPSDistant:0,       //与会展中心的直线距离
                GPSModel:false,
                //交通
                tabsIndex:0,
                tabs:[
                    {
                        name:'公交站',
                        type:0,
                        show:true
                    },
                    {
                        name:'地铁站',
                        type:1,
                        show:true
                    },
                    {
                        name:'停车场',
                        type:2,
                        show:true
                    }
                ],
                trafficState:0,     //0不显示 1：半屏 2：全屏 3：小屏
                trafficLoad:false,
                traffic:[],
                trafficScroll:'',

                //路线
                routeLineSate:0,    //0不显示 1：小屏 2：全屏

                carModel:0,         //驾车模式 0：不是 1是

                routeLoad:false,    //规划加载动画

                routeLines:'',      //路线信息

                routeLinesScroll:'',     //路线

                routeLineName:'',   //目的地名称

                showBrtRoute:false, //展示室内路线
            }
        },

        watch:{

            trafficState(v1){
                if(!v1){
                    this.trafficScroll = '';
                }else if(!this.trafficScroll){
                    this.$nextTick(()=>{
                        this.trafficScroll = new this.$enableScroll({
                            el:this.$refs['trafficScroll']
                        })
                    })
                }

            },

            routeLineSate(v1){
                if(v1 && !this.routeScroll){
                    this.$nextTick(()=>{
                        if(this.routeLines){
                            this.routeLinesScroll = new this.$enableScroll({
                                el:this.$refs['routeLinesScroll']
                            })
                        }
                    })
                }

                if(!v1){
                    this.routeScroll = '';
                }
            }
        },

        methods:{

            back(){
                this.$router.replace('/map')
            },

            back1(enterType){

                /**去掉规划**/
                if(this.$qqmap.map.transferService){
                    this.$qqmap.map.transferService.clear();
                }

                if(this.$qqmap.map.drivingService){
                    this.$qqmap.map.drivingService.clear();
                }

                /**还原地图状态**/
                this.$qqmap.map.setOptions({
                    center:this.$qqmap.centerLatlng,
                    zoom:15
                })

                this.routeLineSate = 0;
                this.routeLines = '';
                this.routeLineName = '';
                this.showBrtRoute = false;

                if(this.$route.query.enterType == 3 || enterType == 3){

                    this.$nextTick(()=>{
                        this.$router.replace('/map')
                    })

                }else{
                    this.$nextTick(()=>{
                        this.$router.replace({
                            path:'/qqRoute',
                            query:this.$route.query
                        })
                    })
                }


            },

            closeSearch(){

                this.searchResult = '';

                if(this.trafficState){
                    this.emptymaker(this.traffic);
                    this.trafficState = 0;
                }

            },

            qqmapMounted(){

                let map = this.$qqmap.map,
                    toChangeMap = false;

                //计算距离
                this.getDistant(d=>{
                    this.GPSDistant = d;
                });


                if(!map.mounted){

                    this.$refs['qqmap-map-section'].appendChild(this.$qqmap.container);
                    map.mountedCallee(this.$refs['qqmap-map-section']);

                    //地图挂在渲染成功
                    map.ready = ()=>{

                        //显示遮罩层
                        this.$qqmap.maskLayers.setVisible(true);

                        //添加覆盖层事件监听
                        let _callback = ()=>{
                            toChangeMap = true;
                        };

                        this.$qqmap.qqMapEvent.addListener(this.$qqmap.maskLayers,'mousedown',e=>{
                            _callback()
                        })

                        this.$qqmap.qqMapEvent.addListener(this.$qqmap.maskLayers,'mousemove',e=>{
                            _callback()
                        })

                        this.$qqmap.qqMapEvent.addListener(this.$qqmap.maskLayers,'click',e=>{
                            _callback()
                        })


                        //移除腾讯地图&版权
                        if(!map.options.logoControl && map.hasLogoAndCopy){
                            map.removeLogoCopyright(this.$refs['qqmap-map-section'])
                        }

                        //添加build marker
                        if(!map.markers.build.isMounted){
                            //防止冲突异步插标
                            map.markers.build.setLatLng(this.$qqmap.centerLatlng);
                            map.markers.build.setVisible(true);
                        }

                        //获取经纬度
                    }

                    let _autoMarkerShow = ()=>{
                        //防止marker被干掉
                        let AUTOMAKERS = document.getElementsByClassName('marker-auto');

                        for (let i=0;i<AUTOMAKERS.length;i++){
                            let marker = AUTOMAKERS[i],
                                parents = marker.parentNode.parentNode;
                            if(parents.style.overflow == 'hidden'){
                                parents.style.overflow = 'inherit'
                            }
                        }

                    }

                    this.$qqmap.qqMapEvent.addListener(map,'zoom_changed',e=>{

                        if(toChangeMap && map.getZoom() >16 && !this.trafficState && !this.routeLineSate){
                            this.back();
                        }

                        _autoMarkerShow();

                        toChangeMap = false;
                    })

                    this.$qqmap.qqMapEvent.addListener(map,'dragend',e=>{
                        _autoMarkerShow();
                    })


                    this.$qqmap.qqMapEvent.addListener(map,'click',e=>{
                        // console.log('点击',e);
                    })


                    //监听拖拽结束
                    this.$qqmap.qqMapEvent.addListener(map,'dragend',e=>{

                        //改为小屏
                        if(this.trafficState === 1){
                            this.trafficState = 3;
                        }

                    })

                }

                //设置级别
                map.setZoom(15);

                let query = this.$route.query;

                if(query.model == 'routeToLine'){
                    //规划线路

                    //清空周边交通
                    this.closeSearch();

                    let start = query.start ?  JSON.parse(query.start) : {name:'我的位置',latlng:this.$qqmap.currentLatlng},
                        end = query.end ? JSON.parse(query.end) : {name:'深圳国际会展中心',latlng:this.$qqmap.centerLatlng,address:'广东省深圳市宝安区福海街道'};


                    let callee = ()=>{
                        this.routeLineName = end.name;

                        //开启规划模式
                        this.routeLineSate = 1;

                        //开启室内路线入口
                        this.showBrtRoute = true;

                        this.carModel = query.vechileIndex == 2 ? true : false;

                        //开始规划
                        this.getRoute(start,end,query.vechileIndex,query.id);
                    }

                    //防止GPS未定到位情况
                    if(!start.latlng){
                        this.getDistant(location=>{
                            if(location){
                                start.latlng = this.$qqmap.currentLatlng;
                                callee &&  callee();
                            }
                            else{
                                this.$message.info('GPS定位失败');
                            }
                        })
                    }else{
                        callee()
                    }

                }

                else if(query.model =='traffic'){

                    if(!this.trafficState){
                        this.getRimTraffic({
                            type:this.$route.query.trafficeIndex
                        },this.$route.query.trafficeIndex)
                    }

                }

            },

            getGPSLocation(callee){

                let $this = this,
                    $mapWxReadyStatus = this.$mapEventManger.mapWxReadyStatus,

                    callback = ()=>{

                        if(this.wx.getLocation){
                            //获取地理位置
                            this.wx.getLocation({

                                type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'

                                success: location=>{
                                    // console.log('location',location);
                                    //记录当前经纬度
                                    $this.$qqmap.currentLatlng = new qq.maps.LatLng(location.latitude,location.longitude);
                                    callee(location)
                                },

                                error(){
                                    callee();
                                }
                            });

                        }
                        else{
                            // console.log('暂不支持获取GPS信息');
                            this.GPSModel = true;
                            // this.$message.info('暂不支持获取GPS信息');
                        }
                    }

                if(!$mapWxReadyStatus){
                    this.$mapEventManger.mapWxReadyEvents.push(callback)
                }else{
                    callback && callback();
                }

            },

            getLngLatToDistant(p1,p2){
                //经纬度计算距离公式

                let rad = (d)=>{
                    return d*Math.PI / 180.0;
                }

                let lat1 = rad(p1.lat),
                    lat2 = rad(p2.lat),
                    a = lat1 - lat2,
                    b = rad(p1.lng) - rad(p2.lng),
                    s = 2 * Math.asin( Math.sqrt( Math.pow(Math.sin(a/2),2)  + Math.cos(lat1)*Math.cos(lat2)*Math.pow(Math.sin(b/2),2) ) );

                    s = s * 6378137.0; // 取WGS84标准参考椭球中的地球长半径(单位:m)
                    s = Math.round( s*10000 ) / 10000;

                    //两点空间距离（非球面体）
                    //s = Math.pow(Math.pow(p1.lng - p2.lng,2) + Math.pow(p1.lat-p2.lat,2),1/2)

                    return s;
            },

            getDistant(callee){

                let d = 0;

                let callback = (location)=>{
                    let p1 = this.$qqmap.centerLatlng,
                        p2 = location; //new qq.maps.LatLng(location.latitude,location.longitude)

                    d = this.getLngLatToDistant(p1,p2);
                    callee && callee(d);
                }

                if(!this.$qqmap.currentLatlng){

                    this.getGPSLocation(location=>{
                        location = new qq.maps.LatLng(location.latitude,location.longitude);
                        callback(location);
                    })

                }else{
                    callback(this.$qqmap.currentLatlng);
                }



            },

            qqmapSearch(param){

                //实例搜索
                let searchServiceCallee  = new qq.maps.SearchService({
                    complete:res=>{
                        param.callee && param.callee(res)
                    },

                    error:err=>{
                        param.callee && param.callee('err')
                    }
                })


                if(param.type == 'bounds'){
                    //根据范围和关键字进行指定区域检索 keyword 、latlngBounds
                    searchServiceCallee.searchInBounds(param.name,param.bounds)

                }

                else if(param.type == 'near'){
                    //根据范围和关键字进行指定区域检索。 (keyword、center、radius
                    searchServiceCallee.searchNearBy(param.name,param.center,param.radius)

                }

                else{
                    //根据关键字发起检索
                    searchServiceCallee.search(param.name)
                }


            },

            getTrafficeSite(siteId){
                //获取公交站点情况
               let stationService = new qq.maps.StationService({
                   complete:res=>{
                       // console.log('获取公交站点情况',res);
                   },
                   error:err=>{
                       // console.log('获取公交站点情况err');
                   }
               })

                stationService.searchById(siteId)
            },

            emptymaker(arr){
                arr.map(item=>{
                    if(item.marker){
                        item.marker.setVisible(false);
                    }
                })
            },

            getRimTraffic(param,index){

                param = param || {};

                let $this = this,
                    type = param.type || 0,
                    name = param.name || '公交站',
                    radius = param.radius || 2000,
                    center = param.center ||  this.$qqmap.centerLatlng;


                if(this.traffic.length)this.emptymaker(this.traffic);
                this.traffic = [];

                this.trafficLoad = true;
                this.tabsIndex = index || 0;
                if(!this.trafficState)this.trafficState = 1;

                //搜索值
                this.searchResult = name;

                let icon = `<i class="iconfont icon-gongjiaoche"></i>`;


                if(type == 1){
                    //地铁站
                    name = '地铁站';

                    icon = `<i class="iconfont icon-ditie"></i>`;

                }
                else if(type == 2){
                    //停车场
                    name = '停车场';

                    icon = `<i class="iconfont icon-tingche"></i>`;

                }



                this.qqmapSearch({
                    type:'near',
                    name:JSON.parse(JSON.stringify(name)),
                    radius:radius,
                    center:center,
                    callee(res){

                        if(res == 'err'){

                            this.$message.info('路线查找失败');

                        }

                        else{

                            let pois = res.detail.pois;

                            let html =  `<div class="marker-auto marker-traffic">
                                <div class="wrap">
                                    <div class="icon">
                                        ${icon}
                                    </div>
                                </div>
                            </div>`;

                            //数据组装
                            pois.map((item,index)=>{

                                //防止带name
                                item.name = item.name.split('[')[0];

                                //获取公交站点情况
                                item.address = item.address.split(',');

                                item.address = item.address.map(child=>{

                                    if(child.indexOf('地铁')>-1){
                                        child = child.replace('地铁','');
                                    }

                                    if(child.indexOf('广东省深圳市')>-1){
                                        child = child.replace('广东省深圳市','');
                                    }

                                    return child;
                                });

                                //添加marker
                                let lngLat = item.latLng; //new qq.maps.LatLng(item.latLng)
                                item.marker = $this.$qqmap.map.addDivMarker({
                                    name:'marker-traffic',
                                    content:html,
                                    center:lngLat
                                });

                                // console.log('item.latLng',item.latLng,'marker',item.marker);
                                if(index < 10){
                                    //显示marker
                                    item.marker.setLatLng(lngLat)
                                }
                            });


                            $this.traffic = pois || [];
                        }

                    }
                });

            },

            enterBrtMap(){
                //进入地图
                this.$router.replace('/map')
            },

            goHere(item){
                let query = this.$route.query,
                    poi = {
                        id:item.id, //唯一标识
                        name:item.name,
                        address:item.address,
                        latlng:new qq.maps.LatLng(item.latLng.lat,item.latLng.lng)
                    };

                query.enterType = 1;
                query.end = JSON.stringify(poi);

                query.trafficeIndex = this.tabsIndex;   //交通标识

                //跳转处理
                this.$router.replace({
                    path:'/qqRoute',
                    query:query
                })

            },

            transferService(start,end,callback){

                //乘车服务
                let $this = this,
                    transferService = $this.$qqmap.map.transferService = new qq.maps.TransferService({
                        map: $this.$qqmap.map
                    });


                //成功
                transferService.setComplete(res=>{

                    res.transferService = transferService;

                    if(res.type == qq.maps.ServiceResultType.MULTI_DESTINATION){
                        //起终点不唯一
                        console.log('起终点不唯一');

                        callback && callback(res,'1');

                    }

                    else{
                        callback && callback(res);
                    }

                })

                //失败
                transferService.setError(err=>{

                    if(err == qq.maps.ServiceErrorType.Error){
                        console.log('乘车服务器异常');
                    }

                    callback && callback(err,'err');
                })

                //设置策略 LEAST_TIME 较快捷 LEAST_TRANSFER 少换乘 LEAST_WALKING 少步行 NO_SUBWAY 不坐地铁
                transferService.setPolicy(qq.maps.TransferPolicy['LEAST_TIME']);

                //设置范围
                // transferService.setLocation('广东省');

                //设置搜索 (start:String | Poi | LatLng, end:String | Poi | LatLng);
                // console.log('start',start,'end',end);

                setTimeout(()=>{
                    transferService.search(new qq.maps.LatLng(start.lat,start.lng),new qq.maps.LatLng(end.lat,end.lng));
                },200)
            },

            drivingService(start,end,callback){
                //乘车服务
                let $this = this,
                    drivingService = $this.$qqmap.map.drivingService = new qq.maps.DrivingService({
                        map: $this.$qqmap.map
                    });

                if($this.$qqmap.map.transferService)$this.$qqmap.map.transferService.clear();

                //成功
                drivingService.setComplete(res=>{

                    if(res.type == qq.maps.ServiceResultType.MULTI_DESTINATION){
                        //起终点不唯一
                        console.log('起终点不唯一');

                        callback && callback(res,'1');

                    }

                    else{
                        callback && callback(res);
                    }

                })

                //失败
                drivingService.setError(err=>{

                    if(err == qq.maps.ServiceErrorType.Error){
                        console.log('乘车服务器异常');
                    }

                    callback && callback(err,'err');
                })

                //设置策略 LEAST_TIME 较快捷 LEAST_TRANSFER 少换乘 LEAST_WALKING 少步行 NO_SUBWAY 不坐地铁
                drivingService.setPolicy(qq.maps.DrivingPolicy['LEAST_TIME']);

                //设置范围
                // drivingService.setLocation('广东省');

                //设置搜索 (start:String | Poi | LatLng, end:String | Poi | LatLng);
                // console.log('start',start,'end',end);
                setTimeout(()=>{
                    drivingService.search(new qq.maps.LatLng(start.lat,start.lng),new qq.maps.LatLng(end.lat,end.lng));
                },300)
            },

            getRoute(startPoi,endPoi,index,caseId,callee){
                //index 1乘车 2驾车

                //caseId 指定方案

                //选用name 或 经纬度作为查询点
                let start = startPoi.latlng;
                let end = endPoi.latlng;

                //开启加载
                this.routeLines = '';
                this.routeLoad = true;

                //多起终点取值
                let getItem = (arr,refer)=>{

                    let r;

                    //校验id
                    if(refer.id){
                        r = arr.filter(item=>{
                            return item.id == refer.id;
                        })
                    }

                    //检验name
                    if(!r || !r.length){
                        r = arr.filter(item=>{
                            return item.name == refer.name;
                        })
                    }

                    r = r && r.length ? r[0] : arr[0];

                    return r;

                };

                if(index == 2){

                    let callback = (res,type)=>{

                        // console.log('驾车规划路线',res);

                        if(type == 'err'){

                            this.routeLoad = false;

                        }

                        else if(type == '1'){

                            //起终点不唯一
                            let s,e;
                            s = getItem(res.detail.start,startPoi);
                            e = getItem(res.detail.end,endPoi);

                            // console.log('s',s,'e',e)

                            if(s.latLng && s.latLng.lat && e.latLng && e.latLng.lat){
                                this.drivingService(s.latLng,e.latLng,callback);
                            }else{
                                this.routeLoad = false;
                            }

                        }

                        else{
                            this.routeLoad = false;
                            this.routeLines = '';
                            if(res.detail.routes && res.detail.routes.length){

                                let lines = [];

                                res.detail.routes.map((item,id)=>{
                                    let name = '方案' + (id+1);

                                    let time = '约';

                                    let h = Math.floor(item.duration / 60),
                                        m = item.duration%60;


                                    if(h>0)time += h + '小时';
                                    time += m + '分钟';

                                    time +='/'+Math.ceil(item.distance/1000) +'公里';

                                    lines.push({
                                        name:name,
                                        time:time,
                                        id:id,     //index为标识
                                        nodes:item.steps
                                    })
                                })

                                let r = lines[0];   //默认取第一个

                                if(caseId){
                                    r = lines.filter(item=>{
                                        return item.id == caseId;
                                    })

                                    if(r.length){
                                        r = r[0]
                                    }else{
                                        r = lines[0]
                                    }
                                }

                                this.routeLines = r;

                            }

                        }

                    };

                    this.drivingService(start,end,callback);
                    // this.drivingService('重庆北站','广东南站',callback);

                }

                else{

                    routeNodes = [];

                    let callback = (res,type)=>{

                        if(type == 'err'){
                            this.routeLoad = false;
                        }

                        else if(type == '1'){
                            //起终点不唯一
                            let s,e;
                            s = getItem(res.detail.start,startPoi);
                            e = getItem(res.detail.end,endPoi);

                            if(s.latLng && s.latLng.lat && e.latLng && e.latLng.lat){
                                this.transferService(s.latLng,e.latLng,callback);
                            }

                            else{
                                this.routeLoad = false;
                            }
                        }

                        else{


                            let getRouteDetail = (routes)=>{

                                this.routeLoad = false;
                                this.routeLines = '';

                                let lines = [];
                                routes.map((item,id)=>{

                                    let name = '';
                                    item.lines.map(child=>{
                                        name +=child.name+'、'
                                    });
                                    name = name.slice(0,name.length-1);

                                    let time = '约';

                                    let h = Math.floor(item.duration / 60),
                                        m = item.duration%60;

                                    if(h>0)time += h + '小时';
                                    time += m + '分钟';
                                    time +='/'+Math.ceil(item.distance/1000) +'公里';


                                    lines.push({
                                        name:name,
                                        time:time,
                                        id:id, //索引作为标识
                                        nodes:item.actions
                                    })
                                })

                                let r = lines[0];   //默认取第一个
                                if(caseId){
                                    r = lines.filter(item=>{
                                        return item.id == caseId;
                                    })

                                    if(r.length){
                                        r = r[0]
                                    }else{
                                        r = lines[0]
                                    }
                                };

                                this.routeLines = r;

                            };

                            if(res.detail.plans && res.detail.plans.length){

                                if(!routeNodes.some(item=>{
                                    return item.nodes
                                }))
                                {

                                    res.detail.plans.map(item=>{
                                        if(item.actions.length){
                                            item.actions.map(child=>{
                                                //步行超过3000米，对这一小段重新规划
                                                if(child.type == 'WALK' && child.data && child.data.distance > 3000){

                                                    let s = child.data.start_location,
                                                        e = child.data.end_location,
                                                        address = child.data.end_address,
                                                        id = child.data.start_location + '' + child.data.end_location;

                                                    //记录路段起终点坐标(起终点相同只记录一次)
                                                    if(!routeNodes.some(item=>{
                                                        return item.id === id
                                                    })){
                                                        routeNodes.push({
                                                            id:id,
                                                            end:e,
                                                            start:s,
                                                            address:address
                                                        })
                                                    }

                                                }
                                            })
                                        }
                                    })

                                    if(routeNodes.length){
                                        let record = 0;

                                        routeNodes.map(item=>{

                                            this.transferService(item.start,item.end,(child,err)=>{
                                                record++;
                                                if(!err && child.detail.plans &&
                                                    child.detail.plans.length &&
                                                    child.detail.plans[0].actions &&
                                                    child.detail.plans[0].actions.length
                                                ){
                                                    //移除地图显示
                                                    setTimeout(()=>{
                                                        child.transferService.clear();
                                                    },300)

                                                    //取第一条
                                                    item.nodes = child.detail.plans[0].actions;

                                                    child.detail.plans[0].actions.map(child1=>{
                                                        if(child1.instructions.indexOf('到达终点') > -1){
                                                            child1.instructions = child1.instructions.replace('到达终点',`到达${item.address || '终点'}`)
                                                        }
                                                    })

                                                }


                                                if(record == routeNodes.length){
                                                    setTimeout(()=>{
                                                        this.transferService(start,end,callback);
                                                    },500)
                                                }
                                            });
                                        })

                                    }

                                    else{
                                        getRouteDetail(res.detail.plans.concat());
                                    }

                                }

                                else{

                                    //替换对应路段
                                    let routes = res.detail.plans.concat();

                                    if(routeNodes.length){
                                        routes.map(item=>{
                                            if(item.actions){

                                                let actions = [];
                                                item.actions.map((child,index)=>{

                                                    let id = child.data.start_location + '' + child.data.end_location;

                                                    let nodes = routeNodes.filter(child1=>{
                                                        return child1.id == id;
                                                    })

                                                    if(nodes.length){
                                                        //替换当前数据
                                                        nodes = nodes[0].nodes;
                                                        if(actions.length){
                                                            actions = actions.concat(nodes);
                                                        }
                                                        else{
                                                            actions = nodes;
                                                        }

                                                    }else{
                                                        actions.push(child)
                                                    }
                                                });

                                                item.actions = actions.concat();

                                            }
                                        })


                                    }

                                    getRouteDetail(routes);
                                }

                            }

                        }

                    }
                    //公交规划路线信息
                    this.transferService(start,end,callback);

                    // this.transferService('重庆北站','广东南站',callback);

                }
            },

            startNav(type){
                //开始导航
                /*

                if(type == 1){
                    let query = this.$route.query;

                    let callback = ()=>{
                        //开始导航
                        let start = query.start ?  JSON.parse(query.start) : {name:'我的位置',latlng:this.$qqmap.currentLatlng},
                            end = query.end ? JSON.parse(query.end) : {name:'深圳国际会展中心',latlng:this.$qqmap.centerLatlng};

                        location.href = `https://apis.map.qq.com/uri/v1/routeplan?type=drive&from=${start.name}&fromcoord=${start.latlng.lat},${start.latlng.lng}&to=${end.name}&tocoord=${end.latlng.lat},${end.latlng.lng}&policy=1&referer=Z5BBZ-AL46F-436JM-NUNY3-RRA4F-QXFEH`;

                    };

                    if(!query.start && !this.$qqmap.currentLatlng){

                        this.getGPSLocation(locate=>{
                            if(locate){
                                callback && callback()
                            }else{
                                this.$message.info('缺少起点');
                            }
                        })

                    }

                    else{
                        callback && callback();
                    }

                }

                else{

                    let locate = this.$qqmap.currentLatlng,
                        end = this.$qqmap.centerLatlng;

                    let callback = (locate)=>{
                        //来管导航
                        location.href = `https://apis.map.qq.com/uri/v1/routeplan?type=drive&from=我的位置&fromcoord=${locate.lat},${locate.lng}&to=深圳国际会展中心&tocoord=${end.lat},${end.lng}&policy=1&referer=Z5BBZ-AL46F-436JM-NUNY3-RRA4F-QXFEH`;
                    };

                    if(!locate){

                        this.getGPSLocation(locate=>{
                            if(locate){
                                callback && callback(locate)
                            }else{
                                this.$message.info('缺少起点');
                            }
                        })

                    }

                    else {
                        callback && callback(locate)
                    }
                }

                 */

                //组装数据
                let query = this.$route.query,
                    end = {};

                if(type == 1){
                    end = query.end ? JSON.parse(query.end) : {name:'深圳国际会展中心',latlng:this.$qqmap.centerLatlng,address:'广东省深圳市宝安区福海街道'};

                    if(end.name == '我的位置'){
                        this.$message.info('终点位置与当前位置一致');
                        return
                    }

                    end.address = end.address || '未知地址';

                }else{
                    end = {name:'深圳国际会展中心',latlng:this.$qqmap.centerLatlng,address:'广东省深圳市宝安区福海街道'};
                }


                //调微信内置地图
                this.wx.openLocation({
                    latitude:end.latlng.lat, // 纬度，浮点数，范围为90 ~ -90
                    longitude: end.latlng.lng, // 经度，浮点数，范围为180 ~ -180。
                    name: end.name, // 位置名
                    address: end.address, // 地址详情说明
                    scale: 1 // 地图缩放级别,整形值,范围从1~28。默认为最大
                });

            },

            showBrtRouteEvent(){
                //显示室内路线
                this.back1(3);
            }
        },

        activated(){

            if(!this.isMounted){
                this.qqmapMounted();
            }else{
                this.isMounted=false;
            }

        },

        mounted() {
            this.isMounted = true;
            this.qqmapMounted();

            // console.log('this.$enableScroll',this.$enableScroll);

            this.$nextTick(()=>{
                new this.$enableScroll({
                    el:this.$refs['qqmap-map-section']
                })
            })
        }
    }
</script>

<style lang="less">
    @import "./../../../styles/index";
    .qqmap-container{
        .absoluteByCover();

        .marker-build{
            position: absolute;
            left: 0px;
            bottom: 0px;
            transform: translate(-50%,50%);
            text-align: center;
            white-space: nowrap;

            >.wrap{

                >.icon{
                    >img{
                        height: @60px;
                    }
                }

                >.label {
                    font-size: @fontSizeA6;
                    color: @themeColor;
                }
            }
        };

        .marker-traffic{
            position: absolute;
            left: 0px;
            bottom: 0px;
            transform: translate(-50%,50%);
            text-align: center;
            white-space: nowrap;

            >.wrap{
                @var:@40px;
                display: flex;
                flex-direction: column;

                &:after{
                    content: "";
                    width: 2px;
                    height: @15px;
                    transform: translate(-50%,0);
                    background-color: @warningColor;
                }

                >.icon{
                    width: @var;
                    height: @var;
                    border-radius:  @var/2;
                    .flexCenter();
                    border: 1px solid @themeReverseColor;
                    background-color: @warningColor;
                    color: @themeReverseColor;
                    transform: translate(-50%,0);
                }
            }
        };



        @var:@standartHeightA4;
        @space:@standartSpaceA4;

        color: @fontColorA2;

        .active(){
            &:active{
                background-color: @bodyBgColor;
            }
        }

        .fontlimite(){
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        >.qqmap-map-section{
            height: 100%;
            width: 100%;
        }

        >.qqmap-top-section{

            .absoluteByCover();
            bottom: auto;

            pointer-events: none;
            padding: @space;
            padding-bottom: 0px;

            >.t1{

                display: flex;

                height: @var;
                font-size: @fontSizeA4;

                >div{
                    background-color: @themeReverseColor;
                    box-shadow: @shadowbox;
                    border-radius: @radiusNumber;
                    pointer-events: auto;
                }


                >.back{

                    .flexCenter();
                    flex-shrink: 0;

                    width: @var;
                    margin-right: @space;

                    .active();
                }

                >.input-box{
                    flex: 1;
                    overflow: hidden;
                    height: inherit;

                    display: flex;
                    align-items: center;


                    &.value{
                        >i{
                            &.icon-close-01{
                                display: flex;
                            }
                        }

                        >.input{
                            color: @fontColorA2;
                        }
                    }


                    >i{

                        .flexCenter();
                        flex-shrink: 0;

                        width: @var;
                        height: inherit;

                        &.icon-close-01{
                            display: none;
                            font-size: @fontSizeA2;
                        }

                        .active();
                    }


                    >.input{

                        color: @fontColorA3;

                        flex: 1;
                        height: inherit;
                        line-height: @var;
                        padding: 0px @8px;

                        .fontlimite();

                        .active();
                    }

                }
            }

            >.t2{

                .absoluteByCover();
                bottom: auto;

                height: @var;
                line-height: @var;

                background-color: @themeReverseColor;
                box-shadow: @shadowbox;
                text-align: center;
                pointer-events: auto;

                >.back{
                    width: @var;
                    height: @var;
                    .absoluteByCover();
                    right: auto;
                    .flexCenter();
                    .active();
                }
            }
        }

        >.qqmap-bottom-section{

            .absoluteByCover();
            top: auto;

            pointer-events: none;

            .box-text-rl(){

                .flexCenter();
                flex-direction: column;
                word-wrap: break-word;/*英文的时候需要加上这句，自动换行*/
                writing-mode: vertical-rl;/*从左向右 从右向左是 writing-mode: vertical-rl;*/
                writing-mode: tb-rl;/*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
                text-align: center;
                letter-spacing: @12px;

            }

            .border-blr(@size){
                &:after{
                    content: "";
                    display: block;
                    position: absolute;
                    bottom: 0px;
                    left: @size;
                    right: @size;
                    border-bottom: 1px solid @borderColorA2;
                }
            }

            >div{
                pointer-events: auto;
            }

            >.b1{

                >.brtmap-enter{

                    .active();

                    width:@var;
                    height: @var;
                    border-radius: @var/2;
                    box-shadow: @shadowbox;
                    .flexCenter();
                    background-color: @themeReverseColor;
                    font-size: @50px;
                    color: @fontColorA2;
                    margin: 0px 0px @space  @space;

                    /*
                    .box-text-rl();

                    width: @var;

                    background-color: @themeReverseColor;
                    box-shadow: @shadowbox;

                    margin-left: @space;
                    margin-bottom: @space;

                    padding:@space 0px;

                    border-radius: @radiusNumber;
                    */

                }

                >.intro-box{

                    background-color: @themeReverseColor;
                    box-shadow: @shadowbox;

                    >.content{
                        padding: @space;
                        position: relative;
                        .border-blr(@size:@space);
                        .active();

                        >.title{
                            font-size: @fontSizeA2;
                            color: #000000;
                        }

                        >.address{
                            padding-top: @10px;
                            color: @fontColorA3;

                            >span{
                                display: inline-block;
                                vertical-align: middle;
                                position: relative;
                                padding:0px @10px;

                                &:first-child{
                                    padding-left: 0px;
                                }

                                &:last-child{
                                    padding-right: 0px;
                                    &:after{
                                        content: none;
                                    }
                                }

                                &:after{
                                    content: "";
                                    display:inline-block;
                                    position: absolute;
                                    top: 25%;
                                    bottom: 25%;
                                    right: 0px;
                                    transform: translateY(25%);
                                    vertical-align: middle;
                                    border-right: 1px solid @fontColorA3;
                                }
                            }
                        }

                    }

                    >.btn{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: @space;



                        >a{
                            flex: 1;

                            height: @var;
                            line-height: @var;

                            border-radius: @var/2;

                            margin-right: @space;

                            text-align: center;
                            color: @themeColor;
                            border: 1px solid @themeColor;

                            &:last-child{
                                margin-right: 0px;
                            }

                            &.active{
                                background-color: @themeColor;
                                color: @themeReverseColor;
                            }

                            &:active{
                                opacity: .8;
                            }

                            >i{
                                margin-right: @10px;
                            }
                        }
                    }

                }

            }

            >.b2{

                height: 0px;
                overflow: hidden;
                display: flex;
                flex-direction: column;

                background-color: @themeReverseColor;
                box-shadow: @shadowbox;
                transition: height 0.3s linear;

                &[state='1']{
                    height: 50vh;
                    transition: height 0.3s linear;

                    >.content{

                        overflow-y: auto;
                        -webkit-overflow-scrolling: touch;

                        &::-webkit-scrollbar{
                            width: 0px;
                            display: none;
                        }

                    }

                }

                &[state='2']{
                    height: 100vh;
                    transition: height 0.3s linear;

                    >.content{

                        overflow-y: auto;
                        -webkit-overflow-scrolling: touch;

                        &::-webkit-scrollbar{
                            width: 0px;
                            display: none;
                        }

                    }
                }

                &[state='3']{

                    height: @140px;

                    transition: height 0.3s linear;

                    >.traffic-min{
                        @var:@80px;
                        display: block;
                        height: @var;
                        line-height:@var;
                        color: @fontColorA3;
                        text-align: center;

                        >font{
                            color: @warningColor;
                        }
                    }

                    >.tabs{
                        display: none;
                    }

                    >.content{
                       display: none;
                    }

                }

                >.traffic-min{
                    display: none;
                }

                >.fold{
                    flex-shrink: 0;
                    text-align: center;
                    height: @space * 2;
                    line-height: @space*2 - @4px;
                    .active();
                }

                >.tabs{

                    padding:0px @space;

                    flex-shrink: 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    border-bottom: 1px solid @borderColorA2;

                    >.l{
                        flex: 1;
                        height: inherit;
                        >ul{
                            >li{
                                display: inline-block;
                                vertical-align: middle;
                                margin-right: @space;
                                padding:  @10px;

                                &:last-child{
                                    margin-right: 0px;
                                }

                                &.active{
                                    position: relative;
                                    color: @themeColor;
                                    &:after{
                                        content: "";
                                        .absoluteByCover();
                                        top: auto;
                                        bottom: -1px;
                                        border-bottom: 2px solid @themeColor;
                                    }
                                }

                                &:active{
                                    opacity: .8;
                                }
                            }
                        }
                    }

                    >.r{
                        >a{
                            display: inline-block;
                            padding: 0px @20px;
                            margin-bottom: @10px;
                            @var:@50px;
                            height: @var;
                            line-height: @var;
                            border-radius: @var/2;

                            font-size: @fontSizeA6;

                            >i{
                                font-size: @fontSizeA6;
                                margin-right: @10px;
                            }
                            &.active{
                                background-color: @themeColor;
                                color: @themeReverseColor;
                            }
                            &:active{
                                opacity: .8;
                            }

                        }
                    }
                }

                >.content{

                    flex: 1;
                    position: relative;

                    >.tip{
                        padding: @10px @space;
                        background-color:fade(@warningColor,5%);
                        color: @warningColor;
                        font-size: @fontSizeA6;
                    }

                    >.load-box{
                        .loadDataBox();
                    }

                    >.empty{
                        height: 100%;
                        width: 100%;
                        .flexCenter();

                        >.box{
                            text-align: center;
                            >i{
                                font-size: @fontSizeA1;
                            }
                            >span{
                                display: block;
                            }
                        }
                    }

                    >ul{

                        >li{
                            padding: @space;
                            padding-bottom: @space - @20px;

                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            position: relative;

                            >.l{
                                overflow-x: hidden;

                                >.title{
                                    color: #000000;
                                    font-size: @fontSizeA3;
                                }

                                >.box{
                                    display: flex;
                                    align-items: flex-start;
                                    overflow: hidden;
                                    padding-top: @space;

                                    >.l{
                                        overflow: hidden;
                                        >span{
                                            position: relative;
                                            padding:@5px 0px;
                                            padding-right: @10px;
                                            white-space: nowrap;
                                            &:after{
                                                content: "";
                                                display:inline-block;
                                                position: absolute;
                                                top: 25%;
                                                bottom: 25%;
                                                right: 0px;
                                                transform: translateY(25%);
                                                vertical-align: middle;
                                                border-right: 1px solid @fontColorA3;
                                            }
                                        }
                                    }

                                    >.r{
                                        flex: 1;
                                        max-width: 100%;
                                        overflow: hidden;
                                        overflow-x: auto;
                                        >span{
                                            display: inline-block;
                                            padding:@5px @20px;
                                            border: 1px solid @themeColor;
                                            border-radius: @40px;
                                            margin-left: @10px;
                                            margin-bottom: @20px;
                                            color: @themeColor;
                                            white-space: nowrap;
                                        }
                                    }
                                }

                            }

                            >.r{
                                flex-shrink: 0;
                                >.icon{
                                    text-align: center;

                                    >i{
                                        @var:@50px;
                                        display: inline-block;
                                        width: @var;
                                        height: @var;
                                        text-align: center;
                                        line-height: @var;
                                        border-radius: @var/2;
                                        background-color: @fontColorA2;
                                        color: @themeReverseColor;
                                    }

                                    >span{
                                        display: block;
                                        margin-top: @10px;
                                        font-size: @fontSizeA6;
                                    }

                                }


                            }

                            &:after{
                                content: "";
                                display: block;
                                .absoluteByCover();
                                top: auto;
                                left: @space;
                                right: @space;
                                border-bottom: 1px solid @borderColorA2;
                            }

                            &:last-child{
                                &:after{
                                    border-bottom: none;
                                }
                            }

                            &:active{
                                opacity: .8;
                            }
                        }
                    }
                }

            }

            >.b3{

                >.brtmap-enter{

                    .active();

                    width:@var;
                    height: @var;
                    border-radius: @var/2;
                    box-shadow: @shadowbox;
                    .flexCenter();
                    background-color: @themeReverseColor;
                    font-size: @50px;
                    color: @fontColorA2;
                    margin: 0px 0px @space  @space;

                    /*
                    .box-text-rl();

                    width: @var;

                    background-color: @themeReverseColor;
                    box-shadow: @shadowbox;

                    margin-left: @space;
                    margin-bottom: @space;

                    padding:@space 0px;

                    border-radius: @radiusNumber;
                    */

                }

                >.main-sec{

                    background-color: @themeReverseColor;
                    display: flex;
                    flex-direction: column;
                    height: 0px;
                    transition: height 3s linear;

                    >.t{
                        >.fold{
                            flex-shrink: 0;
                            text-align: center;
                            height: @space * 2;
                            line-height: @space*2 - @4px;
                            .active();
                        }

                        >.title{
                            display: flex;
                            align-items: flex-start;
                            padding-bottom: @standartSpaceA4;
                            >.l{
                                padding: 0px @space;
                                flex-shrink: 0;
                                @var:@50px;
                                >span{
                                    width: @var;
                                    height: @var;
                                    border-radius: @var/2;
                                    .flexCenter();
                                    color: @themeColor;
                                    background-color: fade(#0465ef,30%);
                                }
                            }
                            >.r{
                                flex: 1;
                                overflow: hidden;
                                >.p1{
                                    flex-shrink: 0;
                                    font-size: @fontSizeA3;
                                    color: #333333;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }

                                >.p2{
                                    flex: 1;
                                    font-size: @fontSizeA5;
                                    color: @fontColorA3;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }
                            }
                        }

                        >.btn-box{
                            display: none;
                            padding: 0px @standartSpaceA4;

                            >a{
                                flex: 1;
                                @var:@80px;
                                height: @var;
                                line-height: @var;
                                border-radius: @var/2;
                                text-align: center;
                                background-color: @themeColor;
                                color: @themeReverseColor;
                            }
                        }
                    }

                    >.c{

                        flex: 0;
                        overflow-y: auto;
                        -webkit-overflow-scrolling: touch;
                        >ul{
                            padding-bottom: @standartSpaceA4;
                            >li{

                                &.start{
                                    >i{
                                        background-color: @successColor;
                                        font-size: @32px;
                                    }
                                }

                                &.end{
                                    >i{
                                        background-color: @warningColor;
                                        font-size: @32px;

                                    }
                                }

                                display: flex;
                                align-items: flex-start;
                                padding: @standartSpaceA4;
                                padding-bottom: 0px;
                                >i{
                                    display: inline-block;
                                    @var:@36px;
                                    width: @var;
                                    height: @var;
                                    border-radius: @var/2;
                                    .flexCenter();
                                    color: @themeReverseColor;
                                    font-size: @fontSizeA6;
                                    font-style: normal;
                                    background-color: fade(@fontColorA3,30%);
                                }
                                >span{
                                    margin-left: @standartSpaceA4/2;
                                    flex: 1;
                                }

                            }
                        }
                    }


                    &[state='1']{
                        height: @200px;
                        transition: height 0.3s linear;

                        &.car{
                            height: @300px;

                            >.t{
                                >.btn-box{
                                    display: flex;
                                }
                            }
                        }
                    }

                    &[state='2']{
                        height: 100vh;
                        transition: height 0.3s linear;

                        >.t{
                            >.title{
                                border-bottom: 1px solid @borderColorA2;
                            }
                        }

                        >.c{
                            flex: 1;
                        }
                    }

                }

                >.load-box{
                    .loadDataBox();
                    height: @300px;
                    background-color: @themeReverseColor;
                    box-shadow: @shadowbox;
                }

                >.empty-box{

                    .flexCenter();

                    height: @300px;
                    background-color: @themeReverseColor;
                    box-shadow: @shadowbox;

                    >.wrap{

                        text-align: center;
                        >i{
                            font-size: @fontSizeA1;
                        }
                        >span{
                            display: block;
                            text-align: center;
                        }
                    }
                }


            }

            /*

            >.b3{

                overflow: hidden;
                display: flex;
                flex-direction: column;
                background-color: @themeReverseColor;
                box-shadow: @shadowbox;
                height: 0px;
                transition: height 0.3s linear;

                &[state='1']{

                    flex-shrink: 0;
                    height: @200px;

                    &.car{
                        height: @300px;

                        >.t-box{
                            >.btn-box{
                                display: flex;
                            }
                        }
                    }

                    >.content{
                        display: none;
                    }

                }



                &[state='2']{
                    height: 100vh;
                    transition: height 0.3s linear;

                    >.t-box{
                        >.title{
                            border-bottom: 1px solid @borderColorA2;
                        }
                    }

                    >.content{
                        flex: 1;
                    }

                }

                >.t-box{
                    >.fold{
                        flex-shrink: 0;
                        text-align: center;
                        height: @space * 2;
                        line-height: @space*2 - @4px;
                        .active();
                    }

                    >.title{
                        display: flex;
                        align-items: flex-start;
                        padding-bottom: @standartSpaceA4;
                        >.l{
                            padding: 0px @space;
                            flex-shrink: 0;
                            @var:@50px;
                            >span{
                                width: @var;
                                height: @var;
                                border-radius: @var/2;
                                .flexCenter();
                                color: @themeColor;
                                background-color: fade(#0465ef,30%);
                            }
                        }
                        >.r{
                            flex: 1;
                            overflow: hidden;
                            >.p1{
                                flex-shrink: 0;
                                font-size: @fontSizeA3;
                                color: #333333;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                            >.p2{
                                flex: 1;
                                font-size: @fontSizeA5;
                                color: @fontColorA3;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                    }

                    >.btn-box{
                        display: none;
                        padding: 0px @standartSpaceA4;

                        >a{
                            flex: 1;
                            @var:@60px;
                            height: @var;
                            line-height: @var;
                            border-radius: @var/2;
                            text-align: center;
                            background-color: @themeColor;
                            color: @themeReverseColor;
                        }
                    }
                }

                >.load-box{
                    .loadDataBox();
                    height: @300px;
                }

                >.empty-box{
                    height: @300px;
                    .flexCenter();
                    >.wrap{

                        text-align: center;
                        >i{
                            font-size: @fontSizeA1;
                        }
                        >span{
                            display: block;
                            text-align: center;
                        }
                    }
                }

                >.content{
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                    >ul{
                        padding-bottom: @standartSpaceA4;
                        >li{
                            display: flex;
                            align-items: flex-start;
                            padding: @standartSpaceA4;
                            padding-bottom: 0px;
                            >i{
                                display: inline-block;
                                @var:@36px;
                                width: @var;
                                height: @var;
                                border-radius: @var/2;
                                .flexCenter();
                                color: @themeReverseColor;
                                font-size: @fontSizeA6;
                                font-style: normal;
                                background-color: fade(@fontColorA3,30%);
                            }
                            >span{
                                margin-left: @standartSpaceA4/2;
                                flex: 1;
                            }

                        }
                    }
                }
            }

             */
        }

        >.GPS-model{
            .fixedByCover();
            background-color: @maskBgColor;
            .flexCenter();
            overflow: hidden;
            z-index: 1000;

            >.wrap{
                display: inline-block;
                width: 80%;
                border-radius: @radiusNumber;
                background-color: @themeReverseColor;
                overflow: hidden;
                box-shadow: @shadowbox;
                text-align: center;

                >.content{
                    padding: @standartSpaceA4 0px;
                    >.p1{
                        font-size: @fontSizeA3;
                        color: @fontColorA1;
                    }

                    >.c{
                        padding: @standartSpaceA4 0px;

                    }

                }

                >.btn{
                    display: flex;
                    border-top: 1px solid @borderColorA2;
                    @var:@80px;
                    >a{

                        flex: 1;
                        height: @var;
                        line-height: @var;
                        &:active{
                            opacity: .8;
                        }
                    }
                }
            }

        }
    }
</style>
